// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Wkji_","bigColWidth":"Table_bigColWidth__24eLc","biggerColWidth":"Table_biggerColWidth__C84Nd","row":"Table_row__p6KEb","col":"Table_col__2f3Ui"};